import { render, staticRenderFns } from "./StopwatchIcon.vue?vue&type=template&id=2d9bb501&scoped=true&"
import script from "./StopwatchIcon.vue?vue&type=script&lang=js&"
export * from "./StopwatchIcon.vue?vue&type=script&lang=js&"
import style0 from "./StopwatchIcon.vue?vue&type=style&index=0&id=2d9bb501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9bb501",
  null
  
)

export default component.exports